var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils.js";
var switchVariants = cva("peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input", {
    variants: {
        size: {
            default: "h-6 w-11",
            sm: "h-5 w-9",
            lg: "h-7 w-13",
        },
    },
    defaultVariants: {
        size: "default",
    },
});
var switchThumbVariants = cva("pointer-events-none block rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0", {
    variants: {
        size: {
            default: "h-5 w-5",
            sm: "h-4 w-4 data-[state=checked]:translate-x-4",
            lg: "h-6 w-6 data-[state=checked]:translate-x-6",
        },
    },
    defaultVariants: {
        size: "default",
    },
});
var Switch = React.forwardRef(function (_a, ref) {
    var className = _a.className, size = _a.size, props = __rest(_a, ["className", "size"]);
    return (_jsx(SwitchPrimitives.Root, __assign({ className: cn(switchVariants({ size: size }), className) }, props, { ref: ref, children: _jsx(SwitchPrimitives.Thumb, { className: cn(switchThumbVariants({ size: size })) }) })));
});
Switch.displayName = SwitchPrimitives.Root.displayName;
export { Switch, switchVariants };
